import { Button } from '@/lib';
import { useUpdateCurrentUserMutation } from '@/services/endpoints/users';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type TermsAndConditionsAcceptButtonProps = {
  onAccept: VoidFunction;
  disabled?: boolean;
};

export const TermsAndConditionsAcceptButton: FC<TermsAndConditionsAcceptButtonProps> = ({ onAccept, disabled = false }) => {
  const { t } = useTranslation();

  const [updateCurrentUser, { isLoading: isLoadingUpdateUserInfo }] = useUpdateCurrentUserMutation();

  const onClick = async () => {
    const response = await updateCurrentUser({
      termsAccepted: true,
    });

    if (response && 'data' in response) {
      onAccept();
    }
  };

  return <Button text={t('COMMON:accept')} onClick={onClick} isLoading={isLoadingUpdateUserInfo} disabled={disabled} size='lg' className='capitalize' />;
};
